<script>
  import { onMount, onDestroy } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Constantes from '../Classes/Constantes.js';
  import { baseUrl } from '../Classes/Stores.js';
  import Conexoes from '../Classes/Conexoes.js';
  let conexao = new Conexoes();
  // Tenta puxar os dados do PIX salvos pela Tela de Vendas ou pela Aba de Créditos
  let pixData = JSON.parse(localStorage.getItem('pixPaymentData') || '{}');
  
  // Extrai as informações principais
  let transactionId = pixData.transaction_id || pixData.id; // Dependendo de como a API MP retornar
  let qrCodeBase64 = pixData.qrCodeBase64 || '';
  let copiaCola = pixData.copiaCola || '';
  let amount = pixData.amount || '4.99';
  let descricao = pixData.description || 'Créditos Hora na Mão';
  
  let statusPagamento = 'pending'; // 'pending', 'approved', 'error'
  let intervaloChecagem;
  let copiado = false;

  onMount(() => {
    // Se não tiver QR Code, volta pro login por segurança
    if (!qrCodeBase64 && !copiaCola) {
      alert("Nenhum pagamento encontrado. Redirecionando...");
      navigate('/login');
      return;
    }
    // A cada 5 segundos, bate no backend para ver se o cliente já pagou
    intervaloChecagem = setInterval(verificarStatus, 5000);
  });

  onDestroy(() => {
    if (intervaloChecagem) clearInterval(intervaloChecagem);
  });

  async function verificarStatus() {
    if (!transactionId) return;
    
    try {
      /*const baseUrlValue = $baseUrl ? $baseUrl.replace(/\/$/, '') : window.location.origin;
      const res = await fetch(`${baseUrlValue}/consultar_pix.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ transaction_id: transactionId })
      });
     const data = await res.json();
      */
      const data = await conexao.conecta(Constantes.api_consultar_pix, { transaction_id: transactionId });
      
     
      
      if (data.status === 'approved') {
        clearInterval(intervaloChecagem);
        statusPagamento = 'approved';
        localStorage.removeItem('pixPaymentData'); // Limpa a memória
        // Registra a venda (Meta Pixel + Google tag)
        try {
          const valor = Number(String(amount).replace(',', '.')) || 0;
          if (typeof fbq === 'function') fbq('track', 'Purchase', { value: valor, currency: 'BRL' });
          if (typeof gtag === 'function') gtag('event', 'purchase', { transaction_id: String(transactionId), value: valor, currency: 'BRL' });
        } catch (e) { console.error('Falha ao registrar compra:', e); }
      }
    } catch (err) {
      console.error("Erro ao verificar PIX:", err);
    }
  }

  function copiarCodigo() {
    navigator.clipboard.writeText(copiaCola).then(() => {
      copiado = true;
      setTimeout(() => copiado = false, 3000);
    });
  }

  function irParaPainel() {
    // O painel manda para o login sozinho se a sessão não existir mais
    navigate('/painel?aba=creditos');
  }
</script>

<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Urbanist:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css">
</svelte:head>

<div class="pix-container">
  <div class="pix-card">
    
   <div class="pix-card">
    <div class="pix-header">
      <div class="logo-container">
        <img src="img/logo2.png" alt="Hora na mão" style="width: 100px; margin-bottom: 10px;" />
      </div>
      <h3 class="brand-name">Hora na Mão</h3>
      <p>Pagamento seguro via PIX (processado pelo Mercado Pago)</p>
    </div>

    </div>

    {#if statusPagamento === 'pending'}
      <div class="pix-body">
        <p class="descricao-plano">{descricao}</p>
        <h3 class="valor-fatura">R$ {parseFloat(amount).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</h3>
        <p class="text-muted">Escaneie o QR Code abaixo com o aplicativo do seu banco:</p>
        
        <div class="qr-code-box">
          {#if qrCodeBase64}
            <img src="data:image/png;base64,{qrCodeBase64}" alt="QR Code PIX">
          {:else}
            <div class="sem-qr">Gerando QR Code...</div>
          {/if}
        </div>

        <div class="copia-cola-section">
          <p class="text-muted" style="font-size: 0.9rem;">Ou use a opção PIX Copia e Cola:</p>
          <div class="input-copia-cola">
            <input type="text" value={copiaCola} readonly>
            <button on:click={copiarCodigo} class={copiado ? 'btn-copiado' : 'btn-copiar'}>
              <i class={copiado ? 'fas fa-check' : 'far fa-copy'}></i> {copiado ? 'Copiado!' : 'Copiar'}
            </button>
          </div>
        </div>

        <div class="loading-status">
          <i class="fas fa-spinner fa-spin"></i>
          <span>Aguardando a confirmação do pagamento...</span>
        </div>
        <p class="aviso-liberacao">Este PIX vale por <strong>10 minutos</strong>. Assim que o banco confirmar, os dias entram na sua conta automaticamente.</p>
        <button class="btn-voltar" on:click={irParaPainel}><i class="fas fa-arrow-left"></i> Voltar ao painel</button>
      </div>
    
    {:else if statusPagamento === 'approved'}
      <div class="pix-success fade-in">
        <div class="icon-circle">
          <i class="fas fa-check"></i>
        </div>
        <h2>Pagamento Aprovado!</h2>
        <p>Seus créditos foram liberados: os dias já entraram na sua conta e a sua agenda continua no ar. Obrigado por confiar no Hora na Mão!</p>
        
        <button on:click={irParaPainel} class="btn-primary w-100 mt-4">
          Acessar Meu Painel <i class="fas fa-arrow-right ms-2"></i>
        </button>
      </div>
    {/if}

  </div>
</div>

<style>
  :root {
    --primary: #4a6c56;
    --primary-dark: #3a5443;
    --accent: #cfaa6c;
    --bg-light: #f4f7f5;
    --text-main: #1a2a20;
    --text-muted: #5a7063;
    --border: #e0e6e2;
    --success: #38a169;
  }

  * { box-sizing: border-box; }

  .pix-container {
    min-height: 100vh;
    background-color: var(--bg-light);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    font-family: 'Urbanist', sans-serif;
    color: var(--text-main);
  }

  .descricao-plano { margin: 0 0 4px 0; font-weight: 700; color: var(--text-muted); text-align: center; }
  .aviso-liberacao { font-size: 0.85rem; color: var(--text-muted); text-align: center; margin: 14px 0 0 0; line-height: 1.5; }
  .btn-voltar { display: block; margin: 14px auto 0 auto; background: none; border: 1px solid var(--border); color: var(--primary); padding: 10px 18px; border-radius: 8px; font-weight: 700; cursor: pointer; font-family: inherit; }
  .pix-card {
    background: white;
    border-radius: 24px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 20px 50px rgba(74, 108, 86, 0.08);
    overflow: hidden;
    border-top: 6px solid var(--primary);
  }

  .pix-header {
    background: #eef5f0;
    padding: 30px 20px;
    text-align: center;
    border-bottom: 1px solid var(--border);
  }

  .logo-icon {
    font-size: 2.5rem;
    color: var(--accent);
    margin-bottom: 10px;
  }

  .pix-header h2 {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.5rem;
    font-weight: 800;
    color: var(--primary);
    margin: 0 0 5px 0;
  }
  
  .pix-header p { margin: 0; color: var(--text-muted); font-weight: 600; }

  .pix-body { padding: 35px 30px; text-align: center; }

  .valor-fatura {
    font-family: 'Montserrat', sans-serif;
    font-size: 2.5rem;
    font-weight: 800;
    color: var(--text-main);
    margin: 0 0 10px 0;
  }

  .text-muted { color: var(--text-muted); }

  .qr-code-box {
    margin: 25px auto;
    padding: 15px;
    background: white;
    border: 2px dashed var(--border);
    border-radius: 16px;
    width: 250px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-code-box img { width: 100%; height: 100%; object-fit: contain; }

  .sem-qr { color: var(--text-muted); font-weight: 600; }

  .copia-cola-section { margin-top: 30px; text-align: left; }

  .input-copia-cola {
    display: flex;
    margin-top: 10px;
    border: 1px solid var(--border);
    border-radius: 8px;
    overflow: hidden;
  }

  .input-copia-cola input {
    flex: 1;
    border: none;
    padding: 12px 15px;
    background: #f8faf9;
    color: var(--text-main);
    font-family: monospace;
    font-size: 0.9rem;
    outline: none;
  }

  .btn-copiar {
    background: var(--primary);
    color: white;
    border: none;
    padding: 0 20px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.2s;
    font-family: inherit;
  }

  .btn-copiar:hover { background: var(--primary-dark); }

  .btn-copiado {
    background: var(--success);
    color: white;
    border: none;
    padding: 0 20px;
    font-weight: 700;
    cursor: default;
    font-family: inherit;
  }

  .loading-status {
    margin-top: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: var(--primary);
    font-weight: 700;
    background: #eef5f0;
    padding: 15px;
    border-radius: 12px;
  }

  .pix-success {
    padding: 50px 30px;
    text-align: center;
  }

  .icon-circle {
    width: 80px; height: 80px;
    background: #e6f4ea;
    color: var(--success);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 2.5rem;
    margin: 0 auto 20px auto;
  }

  .pix-success h2 { color: var(--success); font-family: 'Montserrat', sans-serif; margin-bottom: 15px; }

  .btn-primary {
    background: var(--primary);
    color: white;
    border: none;
    padding: 16px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 1.1rem;
    cursor: pointer;
    transition: 0.3s;
    font-family: inherit;
  }
  
  .btn-primary:hover { background: var(--primary-dark); transform: translateY(-2px); }

  .w-100 { width: 100%; }
  .mt-4 { margin-top: 25px; }
  .ms-2 { margin-left: 8px; }

  .fade-in { animation: fadeIn 0.4s ease-in-out; }

  @media (max-width: 640px) {
    .pix-container {
      padding: 16px;
    }

    .pix-header {
      padding: 24px 16px;
    }

    .pix-header h2 {
      font-size: 1.2rem;
    }

    .valor-fatura {
      font-size: 2rem;
    }

    .pix-body {
      padding: 24px 16px;
    }

    .qr-code-box {
      width: min(100%, 250px);
      height: min(100vw - 24px, 250px);
    }

    .input-copia-cola {
      flex-direction: column;
    }

    .input-copia-cola input,
    .btn-copiar,
    .btn-copiado {
      width: 100%;
      padding: 12px 15px;
    }
  }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>